import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { MdArrowOutward, MdMenuBook } from "react-icons/md";

export default function OneService({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "view",
      subItem: "publication",
      extraItem: data.uuid,
    });
  }

  return (
    <article
      className="publication-card publication-card-shell mShadow1 h-100 d-flex flex-column"
      role="button"
      tabIndex={0}
      onClick={view}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") view();
      }}
    >
      <div className="row align-items-center g-4">
        <div className="col-md-5 mb-3 mb-md-0">
          <img
            src={`${CDN_URL + data.photo}`}
            alt={data.title}
            className="img-fluid publication-image"
          />
        </div>

        <div className="col-md-7">
          <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-3">
            <div>
              <div className="publication-meta-label">Featured Publication</div>
              <div className="publication-date mt-2">
                {data?.dateCreated ? formatDate(data.dateCreated) : "Latest release"}
              </div>
            </div>
            <div className="publication-badge">
              <MdMenuBook size={16} />
              <span>Read Online</span>
            </div>
          </div>

          <h3 className="publication-title">{data.title}</h3>

          <p className="publication-description">
            {data.description || "Open this publication to read it in the viewer."}
          </p>

          
        </div>
      </div>
      <div className="row align-items-center g-4 mt-auto">
        <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="publication-preview-note">
              Click to open the publication viewer
            </div>

            <button
              className="publication-open-btn"
              onClick={(e) => {
                e.stopPropagation();
                view();
              }}
            >
              Open publication <MdArrowOutward className="ms-2" />
            </button>
          </div>
      </div>
    </article>
  );
}
